import { fetchWithErrorHandling } from './apiUtils';

export interface SupportRequestData {
  type: 'Issue' | 'Request';
  phone?: string;
  function_area: string;
  brief_summary?: string;
  description: string;
}

export interface SupportRequestResponse {
  success: boolean;
  message: string;
}

export class SupportService {
  static async submitSupportRequest(
    data: SupportRequestData
  ): Promise<SupportRequestResponse> {
    const endpoint = `/api/v2/support/request`;

    return await fetchWithErrorHandling<SupportRequestResponse>(
      endpoint,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      },
      {
        handle422Errors: true, // Let ApiError handle validation errors
      }
    );
  }
}
